// @flow

import FormSelectField from 'components/FormSelectField'
import PacketSelectField from 'components/PacketSelectField'
import * as React from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import Button from 'ui/atoms/Button'
import Flex from 'ui/atoms/Flex'
import Heading from 'ui/atoms/Heading'
import Modal from 'ui/atoms/Modal'
import Space from 'ui/atoms/Space'
import BlockList from 'ui/molecules/BlockList'
import { ZentakeContext } from 'utils/ZentakeContext'

type Props = {
  onClose: () => void,
}

function KioskModeModal({ onClose }: Props): React.Node {
  const history = useHistory()
  const { userDetails } = React.useContext(ZentakeContext)
  const [showPacket, setShowPacket] = React.useState(false)
  const [selectedForm, setSelectedForm] = React.useState(undefined)
  const [selectedPacket, setSelectedPacket] = React.useState(undefined)

  const handleLaunch = React.useCallback(() => {
    if (!userDetails?.is_verified) {
      toast.warning('Verify Email')
    } else {
      const resourceId = showPacket
        ? selectedPacket?.value
        : selectedForm?.value
      if (!resourceId) {
        toast.warning('Select a resource')
        return
      }
      history.push(`/k/${resourceId}`)
    }
  }, [
    history,
    selectedForm?.value,
    selectedPacket?.value,
    showPacket,
    userDetails?.is_verified,
  ])

  return (
    <Modal dismissOnOutsideClick show>
      <Space size="large">
        <Heading>Launch Kiosk Mode</Heading>

        <Space size="regular">
          <BlockList
            items={[
              {
                active: !showPacket,
                onClick: () => setShowPacket(false),
                label: 'Form',
              },
              {
                active: showPacket,
                onClick: () => setShowPacket(true),
                label: 'Packet',
              },
            ]}
            size="medium"
          />

          {showPacket ? (
            <PacketSelectField
              semibold
              label="Select"
              onChange={(value) => {
                if (!Array.isArray(value)) {
                  setSelectedPacket(value)
                }
              }}
              value={selectedPacket}
            />
          ) : (
            <FormSelectField
              semibold
              label="Select"
              onChange={(value) => {
                if (!Array.isArray(value)) {
                  setSelectedForm(value)
                }
              }}
              value={selectedForm}
            />
          )}
        </Space>

        <Flex $horizontalSpacing="medium" justify="end">
          <Button $block onClick={onClose}>
            Cancel
          </Button>
          <Button $block $primary onClick={handleLaunch}>
            Launch
          </Button>
        </Flex>
      </Space>
    </Modal>
  )
}

export default KioskModeModal
